import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "תוך כמה זמן ניתן לקבל מטפל סיעודי לבית או לבית החולים?",
  answer: "אנו מתחייבים למציאת פתרון והגעת מטפל מקצועי תוך 5 שעות בלבד מרגע הפנייה, בכל רחבי הארץ, כדי להבטיח רצף טיפולי ושקט נפשי למשפחה."
}, {
  question: "האם המטפלים שלכם עוברים הכשרה מקצועית?",
  answer: "בהחלט. כל המטפלים בצוות שלנו עוברים סינון קפדני, בדיקת המלצות והכשרות תקופתיות בתחומי העזרה הראשונה, הטיפול הסיעודי והתמיכה הרגשית בקשישים."
}, {
  question: "האם ניתן לקבל שירות גם בסופי שבוע וחגים?",
  answer: "כן, המוקד שלנו פעיל 24/7 ואנו מספקים שירותי סיעוד מלאים גם בשבתות, חגים ובמצבי חירום בלתי צפויים."
}, {
  question: "מה ההבדל בין מטפל סיעודי בבית לבין השגחה בבית חולים?",
  answer: "מטפל בבית מסייע בשגרת היום-יום ובשמירה על סביבה מוכרת, בעוד שהשגחה בבית חולים נועדה לוודא שהמטופל מקבל את המענה הרפואי הנדרש ואינו נשאר לבד במחלקה."
}, {
  question: "האם ישנה אפשרות להחלפת מטפל במידה ואין התאמה?",
  answer: "בוודאי. החיבור האישי בין המטפל למטופל הוא קריטי להצלחת הטיפול. במידה ואין התאמה מלאה, אנו נדאג להחלפה מהירה של המטפל לשביעות רצונכם."
}, {
  question: "איך מתבצע תהליך התשלום והאם יש סבסוד?",
  answer: "אנו מספקים ייעוץ מלא לגבי מיצוי זכויות מול הביטוח הלאומי וחברות הביטוח הפרטיות. התשלום מתבצע בצורה שקופה ומסודרת בהתאם להיקף השעות הנדרש."
}, {
  question: "באילו ערים אתם מספקים את השירות?",
  answer: "אנו פועלים בפריסה ארצית רחבה, כולל תל אביב, ירושלים, חיפה, באר שבע, נתניה, פתח תקווה וכל היישובים הסמוכים להן."
}];
export default function FaqSection() {
  return <section data-section-id="260604" id="שאלות-נפוצות" className="bg-background text-foreground py-12 px-8">
      <div className="container mx-auto max-w-3xl">
        <h3 className="text-3xl md:text-4xl font-default font-bold text-primary mb-8 text-center">
          שאלות ותשובות נפוצות
        </h3>
        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="bg-card border border-border rounded-lg shadow-md px-4 sm:px-6">
              <AccordionTrigger className="text-right font-default text-base sm:text-lg font-semibold text-foreground hover:no-underline py-4">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground font-default text-sm sm:text-base leading-relaxed pb-4">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}